import { render, staticRenderFns } from "./demandEdit.vue?vue&type=template&id=320b36a7&scoped=true"
import script from "./demandEdit.vue?vue&type=script&lang=js"
export * from "./demandEdit.vue?vue&type=script&lang=js"
import style0 from "./demandEdit.vue?vue&type=style&index=0&id=320b36a7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "320b36a7",
  null
  
)

export default component.exports